const branding = {
  ENERGIC: 'energic',
  VOLTIE: 'voltie',
};

const PortalType = {
  NETWORKS: 'networks',
  PARTNER: 'partner',
  MOBILITY: 'mobility',
  CHARGER: 'devices',
  USERS: 'users',
  APP: 'app',
  ROAMING: 'roaming',
};
const mimeTypes = {
  PNG: 'image/png',
  JPG: 'image/jpg',
  JPEG: 'image/jpeg',
  MP4: 'video/mp4',
  PDF: 'application/pdf',
  MOV: 'video/quicktime',
};
const imageMimeTypes = [mimeTypes.JPG, mimeTypes.PNG, mimeTypes.JPEG];

const videoMimeTypes = [mimeTypes.MP4, mimeTypes.MOV];

const documentMimeTypes = [mimeTypes.PDF];
const deviceModelSeries = [
  {
    label: 'JuiceBox',
    value: 'JuiceBox',
  },
  {
    label: 'Nano Series',
    value: 'Nano Series',
  },
  {
    label: 'Wall Series',
    value: 'Wall Series',
  },
];

const ocppMessageType = {
  RMT_START_TRANSACTION: 'rmt-start-transaction',
  RMT_STOP_TRANSACTION: 'rmt-stop-transaction',
  EC_METER_VALUE: 'ec-meter-value',
  EC_NO_OPERATION: 'ec-no-operation',
  WC_UPDATE_TRANSACTION_ID: 'wc-update-transaction-id',
  RESET_CP: 'reset-cp',
  TRIGGER: 'trigger',
  UNLOCK: 'unlock',
  CONFIGURE: 'configure',
  START: 'start',
  STOP: 'stop',
  ADD_REMOVE_RFID_CARD: 'add-remove-rfid-card',
  CHANGE_CONFIGURATION: 'change-configuration',
  CHANGE_CONFIGURATION_CUSTOM: 'change-configuration-custom',
  CHANGE_AVAILABILITY: 'change-availability',
  CLEAR_CACHE: 'clear-cache',
  GET_CONFIGURATION: 'get-configuration',
  UNLOCK_CONNECTOR: 'unlock-connector',
  SUPER_ADMIN_COMMANDS: 'super-admin-commands',
  GET_COMPOSITE_SCHEDULE: 'get-composite-schedule',
  RESERVE_NOW: 'reserve-now',
  CANCEL_RESERVATION: 'cancel-reservation',
  SEND_LOCAL_LIST: 'send-local-list',
  GET_DIAGNOSTICS: 'get-diagnostics',
  GET_LOCAL_LIST_VERSION: 'get-local-list-version',
  UPDATE_FIRMWARE: 'update-firmware',
  TRIGGER_MESSAGE: 'trigger-message',
  SET_CHARGING_PROFILE: 'set-charging-profile',
  CLEAR_CHARGING_PROFILE: 'clear-charging-profile',
};

const filterType = {
  DATE: 'date',
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  RADIO_BUTTON: 'radio-button',
  SELECT_FIELD: 'list',
  DATE_RANGE: 'dateRange',
  TIME_RANGE: 'timeRange',
  MULTISELECT: 'multiSelect',
  ANGLE_BRACKETS: 'angleBrackets',
} as const; // Prevents additional modification

// Define the type based on filterType object
type FilterType = (typeof filterType)[keyof typeof filterType];

const allStatus = {
  REJECTED: 'rejected',
  PENDING: 'pending',
  FINISHED: 'finished',
  INPROGRESS: 'inProgress',
  ACCEPTED: 'Accepted',
  AVAILABLE: 'Available',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  FAULTED: 'Faulted',
  CHARGING: 'Charging',
};

const chartTimePeriod: {
  label: string;
  value: 'last24hours' | 'last7days' | 'lastMonth' | 'last12months';
}[] = [
  {
    label: '24 hours',
    value: 'last24hours',
  },
  {
    label: '7 Days',
    value: 'last7days',
  },
  {
    label: 'Last Month',
    value: 'lastMonth',
  },
  {
    label: '12 Months',
    value: 'last12months',
  },
];

const connectorStatus = {
  AVAILABLE: 'Available',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  CHARGING: 'Charging',
  SUSPENDED_EVSE: 'SuspendedEVSE',
  SUSPENDED_EV: 'SuspendedEV',
  RESERVED: 'Reserved',
  UNAVAILABLE: 'Unavailable',
  FAULTED: 'Faulted',
};

const chargerType = {
  Personal: 'Personal',
  Commercial: 'Commercial',
};

const desiredPowerOutputUnits = [
  {
    label: 'kW',
    value: 'W',
  },
  {
    label: 'Amps',
    value: 'A',
  },
];

const maxPowerOutputUnits = [
  {
    label: 'kW',
    value: 'kW',
  },
];

const connectorTypes: Record<string, { label: string; value: string }[]> = {
  energic: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'Type2',
      value: 'Type2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
  custom: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'Type2',
      value: 'Type2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
  voltie: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
};
const powerUnit = {
  A: 'Amps',
  KWH: 'kWh',
};

const freeScheduleLimitTypes = [
  {
    label: 'Day',
    value: 'perDay',
  },
  {
    label: 'Week',
    value: 'perWeek',
  },
  {
    label: 'Month',
    value: 'perMonth',
  },
  {
    label: 'Year',
    value: 'perYear',
  },
];

const platformPermissionsOptions = [
  {
    label: 'CPO',
    value: 'cpo',
  },
  {
    label: 'EMSP',
    value: 'emsp',
  },
  {
    label: 'DEVICE',
    value: 'device',
  },
];

enum PhoneNumber {
  MIN_LENGTH = 5,
  MAX_LENGTH = 13,
}

export {
  powerUnit,
  allStatus,
  branding,
  chargerType,
  chartTimePeriod,
  connectorStatus,
  documentMimeTypes,
  filterType,
  FilterType,
  imageMimeTypes,
  mimeTypes,
  ocppMessageType,
  PortalType,
  videoMimeTypes,
  connectorTypes,
  maxPowerOutputUnits,
  desiredPowerOutputUnits,
  deviceModelSeries,
  freeScheduleLimitTypes,
  platformPermissionsOptions,
  PhoneNumber,
};
